import React, { Component, Fragment } from 'react';
import { Table, Segment, Header, Grid, Button, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import NonCycleStudentEditWrapper from '../NonCycleStudentForms/NonCycleStudentEditWrapper';
import NonCycleStudentFaculties from './NonCycleStudentFaculties';

export const getProgramLeadFullName = (nonCycleProgram) => {
    try {
        const person = nonCycleProgram.programLead.employee.person;
        return person.firstName + ' ' + person.lastName;
    } catch (e) {
        return '-';
    }
};

class NonCycleStudentBasicInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            student: props.student,
            editingPersonalInformation: false,
            editingStudyProgramInformation: false,
            unlockLoading: false,
        };
        this.onCancel = this.onCancel.bind(this);
    }

    onCancel = () => {
        this.setState({
            editingPersonalInformation: false,
            editingStudyProgramInformation: false,
        });
    };

    onEdit = (editedStudent) => {
        this.setState({
            student: editedStudent,
            editingPersonalInformation: false,
            editingStudyProgramInformation: false,
        });
        this.props.onEdit(editedStudent);
    };

    render() {
        const {
            editingPersonalInformation,
            editingStudyProgramInformation,
            student,
        } = this.state;

        const { isMainOU } = this.props;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';

        return (
            <Grid columns={2} stackable centered>
                <Grid.Row>
                    <Grid.Column>
                        {editingPersonalInformation
                            ?
                            <NonCycleStudentEditWrapper
                                student={student}
                                personalInformation={true}
                                studyProgramInformation={false}
                                onCancel={this.onCancel}
                                onEdit={this.onEdit}
                            />
                            :
                            <Segment.Group>
                                <Segment>
                                    <Header as="h3">
                                        <Header.Content style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            <FormattedMessage id="externalStudent.personalData"/>
                                            {(isStudentService && isMainOU) &&
                                                (<Popup
                                                    content={<FormattedMessage id="externalStudent.edit"/>}
                                                    position="top center"
                                                    trigger={<Button
                                                        icon="pencil"
                                                        circular
                                                        floated="right"
                                                        basic
                                                        color="green"
                                                        disabled={student.lockedAt || editingPersonalInformation || editingStudyProgramInformation}
                                                        size={'mini'}
                                                        onClick={() => {
                                                            this.setState({ editingPersonalInformation: true });
                                                        }}
                                                    />}/>)}
                                        </Header.Content>
                                    </Header>
                                </Segment>
                                <Segment>
                                    <Table basic="very" compact celled>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.fullName"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.firstName + ' ' + student.lastName}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.email"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.email}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.jmbgAlt"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.jmbg}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.gender"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.gender && student.gender.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.birthDate"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.dateOfBirth ? moment(student.dateOfBirth)
                                                    .format('D. M. YYYY.') : '-'}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.birthCountry"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.birthCountry && student.birthCountry.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.birthPlaceName"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.birthPlaceName}</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Segment>
                            </Segment.Group>
                        }
                        <NonCycleStudentFaculties student={student}/>
                    </Grid.Column>
                    <Grid.Column>
                        {editingStudyProgramInformation ?
                            <NonCycleStudentEditWrapper
                                student={student}
                                personalInformation={false}
                                studyProgramInformation={true}
                                onCancel={this.onCancel}
                                onEdit={this.onEdit}
                            /> :
                            <Segment.Group>
                                <Segment>
                                    <Header as="h3">
                                        <Header.Content style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            <FormattedMessage id="externalStudent.nonCycleStudyProgramData"/>
                                            {(isStudentService && isMainOU) &&
                                                <Popup
                                                    content={<FormattedMessage id="externalStudent.edit"/>}
                                                    position="top center"
                                                    trigger={<Button
                                                        icon="pencil"
                                                        circular
                                                        floated="right"
                                                        basic
                                                        color="green"
                                                        disabled={student.lockedAt || editingPersonalInformation || editingStudyProgramInformation}
                                                        size={'mini'}
                                                        onClick={() => {
                                                            this.setState({ editingStudyProgramInformation: true });
                                                        }}
                                                    />}/>
                                            }
                                        </Header.Content>
                                    </Header>
                                </Segment>
                                <Segment>
                                    <Table basic="very" compact centered relaxed celled>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.programName"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.nonCycleProgram && student.nonCycleProgram.programName}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.nonCycleStudyProgramType"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.nonCycleProgram && student.nonCycleProgram.nonCycleStudyProgramType && student.nonCycleProgram.nonCycleStudyProgramType.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.academicYear"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.academicYear && student.academicYear.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.dateFrom"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.nonCycleProgram && student.nonCycleProgram.dateFrom ? moment(student.nonCycleProgram.dateFrom)
                                                    .format('D. M. YYYY.') : '-'}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.dateTo"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.nonCycleProgram && student.nonCycleProgram.dateTo ? moment(student.nonCycleProgram.dateTo)
                                                    .format('D. M. YYYY.') : '-'}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.programAttendanceType"/>
                                                </Table.Cell>
                                                <Table.Cell>{student.nonCycleProgram && student.nonCycleProgram.attendanceType && student.nonCycleProgram.attendanceType.name}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                                    <FormattedMessage id="externalStudent.programLead"/>
                                                </Table.Cell>
                                                <Table.Cell>{getProgramLeadFullName(student.nonCycleProgram)}</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Segment>
                            </Segment.Group>}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default NonCycleStudentBasicInformation;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentProfile/NonCycleStudentBasicInformation.js